import React, { useRef } from "react";
import * as t from "./types";

interface InputPopupProps {
  course: t.ICourse;
  register: (val: string) => void;
  cancel: () => void;
}

export const InputPopup = (props: InputPopupProps) => {
  const { course, register, cancel } = props;

  const nameRef = useRef<HTMLInputElement>(null);
  /* const x: HTMLInputElement; */
  /* x.value */

  return (
    <div className="form-popup form-container">
      <h3>Regestrierung für Kurs: {course.name}</h3>
      <label htmlFor="name">
        <b>Teilnehmer:</b>
      </label>
      <input
        ref={nameRef}
        type="text"
        placeholder="Name eingeben"
        name="name"
      />
      <button
        className="btn"
        onClick={() => register(nameRef.current?.value || "")}
      >
        Bestätigen
      </button>
      <button className="btn cancel" onClick={() => cancel()}>
        Abbrechen
      </button>
    </div>
  );
};
